import React from "react";
import "../Products/Products.css";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
const FireSystem = ({ title, imageSrc, description }) => {
  const FireSystemDetails = [
    {
      headingname: "Conventional Fire Alarms",
      detailsname:"A conventional fire alarm system is a fire alarm system wired using a radial method .....",
      imageSource:process.env.PUBLIC_URL + "assets/images/Products/Fire-System1.png",
    },
    {
      headingname: "Fire Sprinkler",
      detailsname:"A fire sprinkler system is a type of automatic extinguishing system (AES) that prevents ........",
      imageSource:process.env.PUBLIC_URL +"assets/images/Products/Fire-System2.png",
    },
    {
      headingname: "Hose Reel ",
      detailsname:"A hose reel is a cylindrical spindle made of either metal, fiberglass, or plastic and is used....",
      imageSource:process.env.PUBLIC_URL +"assets/images/Products/Fire-System-3.png",
    },
    {
      headingname: "Smoke Detector",
      detailsname:"Smoke alarms detect fires by sensing small particles in the air using a couple of ........",
      imageSource:process.env.PUBLIC_URL +"assets/images/Products/Fire-System4.png" ,
    },
    {
      headingname: "Fire Extinguisher",
      detailsname:"fire extinguisher, portable or movable apparatus used to put out a small fire by directing .........",
      imageSource:process.env.PUBLIC_URL +"assets/images/Products/Fire-System5.png ",
    },
  ];
  return (
    <>
      <section className="CCTV-System">
        <div className="container">
          <div className="Heading-cctv">
            <div className="heading-about text-center">
              <h4>Fire Systems</h4>
            </div>
            <div className="borders d-flex justify-content-center">
              <div className="border-red"></div>
              <div className="border-line "></div>
            </div>
          </div>

          <div className="row justify-content-center">
            {FireSystemDetails.map((item, index) => (
              <div key={index} className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-12 mt-4 mt-xl-5 g-5">
                <Card className="IR-Camera mb-3">
                  <Card.Img variant="top" />
                  <div className="Heading-Main">
                    <h1 className="dome-camera">{item.headingname}</h1>
                  </div>

                  <div className="camera-border"></div>
                  <div className="IR-camera-img">
                    <img src={item.imageSource} className="camera-img" />
                  </div>
                  <Card.Body className="IR-Camera-body">
                    <Card.Text>{item.detailsname}</Card.Text>
                    <div className="read-button">
                      <Button variant="read">Read More</Button>
                      <div className="read-border"></div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default FireSystem;
